import React from "react";

const OtherSection = ({ children }) => {
  return <div className="pb-20 space-y-10">{children}</div>;
};

export default OtherSection;
